import type {
  AirportRecommend,
  BoxSearchInterface,
  FlightAirport,
  ListMonth,
  ThingsToKnow,
} from "../flightAirportInterface";
import { AirportRecommendClass } from "./airportRecommendClass";
import { BoxSearchClass } from "./boxSerchClass";
import { ListMonthClass } from "./listMonthClass";
import { ThingsToKnowClass } from "./thingsToKnowsClass";

export class FlightAirportClass implements FlightAirport {
  airportRecommend: AirportRecommend[] = [];

  boxSearch: BoxSearchInterface = new BoxSearchClass();

  currency: string = "";

  listMonth: ListMonth[] = [];

  thingsToKnow: ThingsToKnow = new ThingsToKnowClass();

  constructor(data?: FlightAirport) {
    if (!data) return;
    this.airportRecommend = (data?.airportRecommend ?? []).map(
      (item) => new AirportRecommendClass(item),
    );
    this.currency = data?.currency ?? "";
    this.boxSearch = new BoxSearchClass(data?.boxSearch);
    this.thingsToKnow = new ThingsToKnowClass(data?.thingsToKnow);
    this.listMonth = (data?.listMonth ?? []).map(
      (item) => new ListMonthClass(item),
    );
  }
}
